module.exports = __webpack_public_path__ + "assets/4d07efc947e22a56da8694550de5fc84.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/BgmFg.mp3
 ** module id = 343
 ** module chunks = 0
 **/